export default {
  getDictionary: "/sys/dic/query/{type}", //字典
  getAllDepart: "/department/query", //部门
  getDepart: "/department/querybypid", //根据用户权限获取部门
  getPostByDepartId: "/position/departposition", //部门id查职位
  getPersonByDepartId: "/employee/organizeemployee", //根据部门id查询员工信息
  getPersonByPostId: "/employee/permission/{positionId}", //根据职位查询员工名称
  getCompany: "/company/queryuser", //根据用户权限获取分公司
  getBelonger: "/talents/getbelonger", //人才储备列表-查询归属人API
  getUnder: "/employee/searchunderlings", //查询下属在职人员API
  getAll: "/employee/searchallemp", //查询所有在职人员API
  getProvince: "/employee/selectareaall", //查询省市区API
  getNumber: "/employee/workingrules/{id}", //查询工号API
  ssoUpload: `#file#/sts/authorization?type=1&system=oa`, //sso
  getApprovalStatus: "/system/approvalstatus", //审批状态
  getApprovalType: "/system/approvaltype", //审批类型
  getApp: "/system/getmenucode", //获取应用
  getLevel: "/system/getpermissiontype", //获取权限等级
  getAllPermission: "/menupermission/getallpermission", //根据应用id获取页面权限
  getunderlings: "/employee/getunderlings", //根据登陆人获取下属员工API
  getcompanydomains:"/company/domain/getcompanydomains", //获取公司域名
  getCourierCompany:"/express/getCompDictionary",//获取快递公司
  getCourierState:"/express/getTrackDictionary",//获取快递状态
  getAppName:"/express/getAppNamDictionary",//获取发件系统
  getCompanyByExpress: "/company/getUserCompanyExpress",//查询职位分公司信息-快递使用
  leavatype: "/system/leavatype",//请假类型
}



// WEBPACK FOOTER //
// ./src/api/config/common.js